/**
 * @module recorder/recorderstyle
 */
import { Plugin } from '@ckeditor/ckeditor5-core';

import RecorderStyleEditing from './recorderstyle/recorderstyleediting';
import RecorderStyleUI from './recorderstyle/recorderstyleui';

export default class RecorderStyle extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [ RecorderStyleEditing, RecorderStyleUI ];
    }

    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'RecorderStyle';
    }
}
